import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { gogLink } from '../lib/affiliate';

function GogCta() {
  const { t } = useTranslation();
  const verdict = useSelector((s) => s.scan.verdict);
  const savable = (verdict?.items ?? []).filter((i) => i.savable);

  return (
    <section className="gog-cta">
      <div className="gog-cta__inner">
        <h2 className="gog-cta__title">{t('cta.title')}</h2>
        <p className="gog-cta__body">{savable.length ? t('cta.body') : t('cta.none')}</p>
        {savable.length > 0 && (
          <div className="gog-cta__list">
            {savable.map((i) => (
              <a
                key={i.appId}
                className="gog-chip"
                href={gogLink(i.gogUrl)}
                target="_blank"
                rel="noreferrer"
              >
                <span className="gog-chip__name">{i.name}</span>
                <span className="gog-chip__action">{t('cta.button')} →</span>
              </a>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default GogCta;
